const FullScreenLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader" />
    </div>
  );
};

export default FullScreenLoader;
